import parse, { Element } from 'html-react-parser';

// Components
import { Img } from '../style';

const addImg = ['img'];

export const bannerParser = (str: string = '') => {
  const options = {
    replace(domNode: Element) {
      const { name = '' } = domNode;

      if (addImg.includes(name)) {
        const { attribs }: { attribs?: any; children?: any } = domNode;

        return (
          <Img
            src={attribs.src}
            width={300}
            height={500}
            objectFit="fill"
            priority
            alt="bannerImage"
            quality={60}
          />
        );
      }

      return domNode;
    },
  };
  // @ts-ignore
  return parse(str, options);
};
